// src/slices/10-forms/thunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;
const cleanData = (data) => {
  return Object.fromEntries(Object.entries(data).map(([key, value]) => [key, value ?? ""]));
};

// -----------------------------
// Training Form
// -----------------------------
export const sendForm = createAsyncThunk("form/sendForm", async (formData, { rejectWithValue }) => {
  try {
    const tokenData = JSON.parse(sessionStorage.getItem("authUser"));
    const token = tokenData?.data?.token;

    const headers = { "Content-Type": "application/json" };
    if (token) headers.Authorization = `Bearer ${token}`;

    const response = await axios.post(`${API_URL}/trainingForm`, cleanData(formData), { headers });

    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || "Failed to submit training form");
  }
});

// -----------------------------
// Meeting Form
// -----------------------------
export const sendMeetingform = createAsyncThunk("form/sendMeetingform", async (formData, { rejectWithValue }) => {
  try {
    const tokenData = JSON.parse(sessionStorage.getItem("authUser"));
    const token = tokenData?.data?.token;

    const headers = { "Content-Type": "application/json" };
    if (token) headers.Authorization = `Bearer ${token}`;

    const finalData = cleanData({ ...formData, meetingRoom: formData.meetingRoom || "" });

    const response = await axios.post(`${API_URL}/meetingForm`, finalData, { headers });

    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || "Failed to submit meeting form");
  }
});

// -----------------------------
// Booking Form
// -----------------------------
export const sendBookingForm = createAsyncThunk("form/sendBookingForm", async (formData, { rejectWithValue }) => {
  try {
    const tokenData = JSON.parse(sessionStorage.getItem("authUser"));
    const token = tokenData?.data?.token;

    const headers = { "Content-Type": "application/json" };
    if (token) headers.Authorization = `Bearer ${token}`;

    const finalData = cleanData({
      ...formData
      // bookingType: formData.bookingType || "",
    });

    const response = await axios.post(`${API_URL}/bookingForm`, finalData, { headers });

    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || "Failed to submit booking form");
  }
});

// -----------------------------
// Consulting Form
// -----------------------------
export const sendConsultingForm = createAsyncThunk("forms/sendConsultingForm", async (payload, { rejectWithValue }) => {
  try {

    const res = await axios.post(`${process.env.REACT_APP_API_URL}/consultingForm  `, payload, { headers: { "Content-Type": "application/json" } });

    return res.data;
  } catch (err) {
    console.error("❌ API ERROR 👉", err.response || err);
    return rejectWithValue(err.response?.data || err.message);
  }
});
